import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessTimelineCustomEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-timeline-custom-embed',
	path: '/jira/core/projects/:projectKey/timeline/:viewId/embed',
	exact: true,
};
